export default {
    /**
     * 四舍五入保留两位小数，若第二位是0则忽略
     * @param {*} num
     * step 保留多少位小数 默认两位传100 4位小数传1000
     */
    keepTwoDecimal(num, step=100) {
        var result = parseFloat(num);
        if (isNaN(result)) {
            console.error("参数非数值，无法四舍五入保留两位小数！");
            return false;
        }
        result = Math.round(num * step) / step;
        return result;
    },
};
